@if (!(isLoading$ | async)) {
  <div class="edit-form__wrapper grid grid-cols-1 divide-y bg-white">
    @if (accountData) {
      <div class="hidden"></div>
      <app-edit-customer-information
        [customerInformation]="customerDetails"
      ></app-edit-customer-information>
      <app-edit-location-details
        [locationDetails]="locationDetails"
      ></app-edit-location-details>
      <app-edit-means-of-id
        [meansOfId]="meansOfIdDetails"
      ></app-edit-means-of-id>
      <app-edit-employment-details
        [employmentDetails]="employmentDetails"
      ></app-edit-employment-details>
      <app-edit-next-of-kin
        [nextOfKinDetails]="nextOfKinDetails"
      ></app-edit-next-of-kin>
      <app-edit-bank-details
        [bankDetails]="bankDetails"
      ></app-edit-bank-details>
      <app-edit-documents [kycDocuments]="documentDetails"></app-edit-documents>
      <div></div>
    }
  </div>
} @else {
  <div class="flex flex-col">
    <ngx-skeleton-loader
      *ngFor="let in of [0, 1, 2, 3, 4, 5, 6]; let i = index"
      [theme]="{ height: '5rem', width: '100%' }"
    ></ngx-skeleton-loader>
  </div>
}
